module.exports = __webpack_public_path__ + "img/b2b.0ae9539d.svg";